.fixedFooter {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--hps-white);
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
    z-index: 100;
    /* Try to keep the same height as the logo footer of the nav bar, which looks more visually coherent. */
    min-height: 84px;
}

.footerContent {
    max-width: 1300px;
    margin: auto;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.footerWithNavOpen {
    margin-left: 300px;
}

.footerInfo {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-right: 8px;
}

.footerActions {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.saveButtons {
    display: flex;
    flex-direction: row;
    gap: 12px;
}